import { render, staticRenderFns } from "./ParamTipoEmail.vue?vue&type=template&id=42e85797"
import script from "./ParamTipoEmail.vue?vue&type=script&lang=js"
export * from "./ParamTipoEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports